webpackJsonp([10],{

/***/ "1mgF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactApollo = __webpack_require__("3zLD");

var _graphqlTag = __webpack_require__("tlQw");

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

var _constructQuery = __webpack_require__("YNt2");

var _tulkojumi = __webpack_require__("Ky/6");

var _tulkojumi2 = _interopRequireDefault(_tulkojumi);

var _layout = __webpack_require__("ROvt");

var _elements = __webpack_require__("y9nW");

var _pages = __webpack_require__("04qB");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var withTermsPostQuery = function withTermsPostQuery(postType, termsArray, lang, tekstiArray) {
  var QUERY = (0, _graphqlTag2.default)((0, _constructQuery.constructQueryForPostTerms)(termsArray, tekstiArray));

  var queryOptions = {
    options: function options(_ref) {
      var lang = _ref.lang,
          postId = _ref.postId;
      return {
        fetchPolicy: 'cache-first',
        variables: {
          lang: lang || 'lv',
          postId: postId
        }
      };
    },
    props: function props(_props) {
      var _props$data = _props.data,
          loading = _props$data.loading,
          page = _props$data.page,
          teksti = _props$data.teksti,
          lang = _props$data.variables.lang,
          rest = _objectWithoutProperties(_props$data, ['loading', 'page', 'teksti', 'variables']);

      return {
        loading: loading,
        page: Array.isArray(page) && page.length > 0 ? page[0] : page,
        teksti: teksti,
        lang: lang
      };
    }
  };

  var TermsPost = function TermsPost(props) {
    var loading = props.loading,
        page = props.page,
        lang = props.lang,
        teksti = props.teksti;


    if (loading) {
      return null;
    }

    // TODO: Kļūdas paziņojums.
    // Kā tam vajadzētu funkcionēt?
    if (!page) {
      return _react2.default.createElement(
        _layout.SiteContainer,
        null,
        _react2.default.createElement(
          _elements.Heading,
          null,
          (0, _tulkojumi2.default)(teksti, 'notikusi_kluda')
        )
      );
    }

    return _react2.default.createElement(_pages.Dokumenti, {
      postType: postType,
      data: _extends({}, props)
    });
  };

  return (0, _reactApollo.compose)((0, _reactApollo.graphql)(QUERY, queryOptions))(TermsPost);
};

exports.default = withTermsPostQuery;

/***/ }),

/***/ "6YA4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _withTermsPostQuery = __webpack_require__("1mgF");

var _withTermsPostQuery2 = _interopRequireDefault(_withTermsPostQuery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IepirkumiDefault = function IepirkumiDefault(props) {
  var PageWithTermsPost = (0, _withTermsPostQuery2.default)('iepirkumi', ['iepirkumi_tags', 'iepirkumi_veidi', 'iepirkumi_statuss', 'iepirkumi_liguma_veidi'], props.lang, ['dokumenti', 'notikusi_kluda', 'iestade', 'publicets', 'iesniegsanas_termins', 'lemuma_datums', 'atjaunots', 'iepirkumi', 'piezimes', 'lapas', 'kontakti', 'tel', 'fakss']);
  return _react2.default.createElement(PageWithTermsPost, props);
};

exports.default = IepirkumiDefault;

/***/ }),

/***/ "YNt2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var constructQueryForTerms = exports.constructQueryForTerms = function constructQueryForTerms(type, terms, teksti) {
  var query = '\n    query RezultatiQuery($lang: String!, $page: Int, $perpage: Int, $orderby: [String], $order: [String], $search: String, $from: Int, $to: Int, ' + terms.map(function (term) {
    return '$' + term + ': [String]';
  }).join(', ') + ') {\n      ' + type + '(lang: $lang, page: $page, perpage: $perpage, orderby: $orderby, order: $order, search: $search, from: $from, to: $to, ' + terms.map(function (term) {
    return term + ': $' + term;
  }).join(', ') + ') {\n        page\n        perpage\n        total\n        ' + constructTermsPartial(terms, ['slug', 'name', 'count']) + '\n        posts {\n          _id\n          path\n          title\n          date_created\n          date_modified\n          acf\n          ' + constructTermsPartial(terms, ['slug', 'name']) + '\n        }\n      }\n      ' + constructTekstiPartial(teksti) + '\n    }\n  ';
  return query;
};

var constructQueryForPostTerms = exports.constructQueryForPostTerms = function constructQueryForPostTerms(terms, teksti) {
  var query = '\n    query PostQuery($lang: String!, $postId: [Int]!) {\n      page(lang: $lang, _id: $postId) {\n        path\n        date_created\n        date_modified\n        title\n        content\n        acf\n        ' + constructTermsPartial(terms) + '\n      }\n      ' + constructTekstiPartial(teksti) + '\n    }\n  ';

  return query;
};

var constructTermsPartial = exports.constructTermsPartial = function constructTermsPartial(terms) {
  var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['name'];

  if (terms && Array.isArray(terms) && terms.length > 0) {
    return '\n      terms {\n        ' + terms.map(function (term) {
      return '\n        ' + term + ' {\n          ' + keys.map(function (key) {
        return key;
      }).join('\n') + '\n        }\n      ';
    }).join('') + '\n      }\n    ';
  }
  return '';
};

var constructTekstiPartial = exports.constructTekstiPartial = function constructTekstiPartial(teksti) {
  if (teksti && Array.isArray(teksti) && teksti.length > 0) {
    return '\n      teksti(lang: $lang, _id: [' + teksti.map(function (id) {
      return '"' + id + '"';
    }).join(', ') + ']) {\n        _id\n        text\n      }\n    ';
  }
  return '';
};

var constructTermsObj = exports.constructTermsObj = function constructTermsObj(terms) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var obj = {};
  terms.forEach(function (term) {
    obj[term] = data && data[term] ? data[term] : null;
  });
  return obj;
};

/***/ })

});


// WEBPACK FOOTER //
// IepirkumiDefault.e6e92c49db27ee8d1ba5.js